module.exports = __webpack_public_path__ + "static/XE3-85c38f46a527815ca51185cf1334b4ea.png";